module.exports = __webpack_public_path__ + "assets/img/26_1588_big.dc8ed88a.jpg";